/* eslint-disable @typescript-eslint/indent */
/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import { TableContainer, Table, Thead, Tr, Tbody, Avatar, Text, Flex } from '@chakra-ui/react'
import { OutlineTable, StyledSpan } from './styles'
import { iParticipanteInvalido } from '../../../../interfaces'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { useState } from 'react'
import { ModalChangeResponsavel } from '../ModalChangeResponsavel'

interface iProps {
  participantesInvalidos: iParticipanteInvalido[]
	onRender: () => void
}

export const TabelaParticipantesInvalidos: React.FC<iProps> = ({ participantesInvalidos, onRender }) => {
	const [ColaboradorId, setColoradorId] = useState<string>()

  return (
		<>
			{ColaboradorId && <ModalChangeResponsavel
				colaboradorId={ColaboradorId}
				isOpen
				onConfirm={() => { onRender(); setColoradorId(undefined) }}
				onRequestClose={() => setColoradorId(undefined)}
			/>}
			<OutlineTable>
				<TableContainer>
					<Table variant='simple'>
						<Thead>
							<Tr _hover={{ bg: 'var(--c1) !important', color: 'black' }}>
								<th>Participante</th>
								<th>Motivo</th>
								<th></th>
							</Tr>
						</Thead>
						<Tbody>
							{participantesInvalidos?.sort((a, b) => a.colaborador.nome.localeCompare(b.colaborador.nome)).map((e, i) => {
							  return (
									<Tr key={i}>
										<td>
											<StyledSpan style={{ justifyContent: 'start', padding: '.5rem 1rem' }}>
												<Avatar src={e.colaborador.avatar} width={'2rem'} h={'2rem'} />
												<Text color={'Gray1'} fontWeight={'600'} fontSize={'12px'}>
													{e.colaborador.nome}
												</Text>
											</StyledSpan>
										</td>

										<td>
											<StyledSpan>
												<Text color={'Gray1'} fontWeight={'600'} fontSize={'12px'} pl={'1.25rem'}>{e.motivo}</Text>
											</StyledSpan>
										</td>
										<td>
											<Flex justifyContent={'end'} pr={'1rem'}>
												<ButtonCmp VarColor='Green2' onClick={() => setColoradorId(e.colaborador.id)}>Atualizar responsável</ButtonCmp>
											</Flex>
										</td>
									</Tr>
							  )
							})}
						</Tbody>
					</Table>
				</TableContainer>
			</OutlineTable>
		</ >
  )
}
